import { BigNumber } from 'ethers'

type ChainConfig = {
  router: string
  creationBlock: number
  weth: string
}

const WETH_NOT_SUPPORTED_ON_CHAIN = '0x0000000000000000000000000000000000000000'

const CHAIN_CONFIGS: { [key: number]: ChainConfig } = {
  // mainnet
  [1]: {
    router: '0xEf1c6E67703c7BD7107eed8303Fbe6EC2554BF6B',
    weth: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    creationBlock: 17143817,
  },
  // goerli
  [5]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
    creationBlock: 9327169,
  },
  // sepolia
  [11155111]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
    creationBlock: 3543575,
  },
  // polygon
  [137]: {
    router: '0x60Ab3B2D960c851F14B23B6Af579800cdC42F457',
    weth: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    creationBlock: 46977633,
  },
  //polygon mumbai
  [80001]: {
    router: '0x3982C82b93cbE5796c9F8410855E4b01C2C6d0C5',
    weth: '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889',
    creationBlock: 39276764,
  },
  //optimism
  [10]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 96333990,
  },
  // optimism goerli
  [420]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: '0x4200000000000000000000000000000000000006',
    creationBlock: 8887728,
  },
  // arbitrum
  [42161]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    creationBlock: 87206402,
  },
  // arbitrum goerli
  [421613]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: '0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3',
    creationBlock: 18815277,
  },
  // celo
  [42220]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: WETH_NOT_SUPPORTED_ON_CHAIN,
    creationBlock: 19106929,
  },
  // celo alfajores
  [44787]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: WETH_NOT_SUPPORTED_ON_CHAIN,
    creationBlock: 17566658,
  },
  // binance smart chain
  [56]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    creationBlock: 27915533,
  },
  // avalanche
  [43114]: {
    router: '0x4b8fB98B4E3e616DEd693Eea3cC50AB895f898a1',
    weth: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
    creationBlock: 31583684,
  },
}

export const UNIVERSAL_ROUTER_ADDRESS = (chainId: number): string => {
  console.log(CHAIN_CONFIGS)

  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)
  const temp = CHAIN_CONFIGS[chainId].router
  console.log('ARYZE DEBUGER: ' + temp)
  return temp
}

export const UNIVERSAL_ROUTER_CREATION_BLOCK = (chainId: number): number => {
  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)
  return CHAIN_CONFIGS[chainId].creationBlock
}

export const WETH_ADDRESS = (chainId: number): string => {
  if (!(chainId in CHAIN_CONFIGS)) throw new Error(`Universal Router not deployed on chain ${chainId}`)

  if (CHAIN_CONFIGS[chainId].weth == WETH_NOT_SUPPORTED_ON_CHAIN) throw new Error(`Chain ${chainId} does not have WETH`)

  return CHAIN_CONFIGS[chainId].weth
}

export const PERMIT2_ADDRESS = '0x13bbe0e015ADc83cE86e9CBd99A1164B37a01bB5' //ARYZE

export const CONTRACT_BALANCE = BigNumber.from(2).pow(255)
export const ETH_ADDRESS = '0x0000000000000000000000000000000000000000'
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
export const MAX_UINT256 = BigNumber.from(2).pow(256).sub(1)
export const MAX_UINT160 = BigNumber.from(2).pow(160).sub(1)

export const SENDER_AS_RECIPIENT = '0x0000000000000000000000000000000000000001'
export const ROUTER_AS_RECIPIENT = '0x0000000000000000000000000000000000000002'

export const OPENSEA_CONDUIT_SPENDER_ID = 0
export const SUDOSWAP_SPENDER_ID = 1
